import React from "react";
import {
  Swords,
  Flame,
  Calendar,
  Shield,
  Hammer,
  Trophy,
  Star,
  Gem,
  ChevronsUp,
  Crown,
  Lock,
} from "lucide-react";
import { ACHIEVEMENTS } from "../lib/gameLogic";

const ICONS = { Swords, Flame, Calendar, Shield, Hammer, Trophy, Star, Gem, ChevronsUp, Crown };

export default function Achievements({ unlocked }) {
  const total = ACHIEVEMENTS.length;
  const count = Object.keys(unlocked || {}).length;
  return (
    <div data-testid="achievements-panel" className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-[0.3em] text-blue-400/80 flex items-center gap-1.5">
          <Trophy className="h-3 w-3" /> // Titles & Trophies
        </div>
        <div className="font-mono text-xs text-slate-400">
          <span className="text-purple-300 text-base font-bold">{count}</span> /{" "}
          {total} unlocked
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-[480px] overflow-y-auto pr-1">
        {ACHIEVEMENTS.map((a) => {
          const isUnlocked = !!unlocked?.[a.id];
          const Ico = ICONS[a.icon] || Trophy;
          return (
            <div
              key={a.id}
              data-testid={`achievement-${a.id}${isUnlocked ? "-unlocked" : "-locked"}`}
              className={`relative border p-3 flex items-start gap-3 transition ${
                isUnlocked
                  ? "border-purple-500/40 bg-gradient-to-br from-purple-500/10 to-blue-500/5"
                  : "border-white/10 bg-black/30"
              }`}
            >
              <div
                className={`relative h-10 w-10 shrink-0 border flex items-center justify-center ${
                  isUnlocked
                    ? "border-purple-400 bg-purple-500/20 text-purple-200"
                    : "border-white/10 bg-black/40 text-slate-700"
                }`}
              >
                {isUnlocked ? (
                  <Ico className="h-5 w-5" />
                ) : (
                  <Lock className="h-4 w-4" />
                )}
                {isUnlocked && (
                  <div className="absolute -inset-px ring-glow-purple opacity-60 pointer-events-none" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div
                  className={`font-display uppercase tracking-wider text-sm ${
                    isUnlocked ? "text-white" : "text-slate-600"
                  }`}
                >
                  {a.title}
                </div>
                <div
                  className={`text-[11px] font-mono mt-0.5 leading-snug ${
                    isUnlocked ? "text-slate-300" : "text-slate-700"
                  }`}
                >
                  {a.desc}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
